import type { LocationBoundary } from '@aloft/toolkit-shared';

import type { CompSearch } from '../types.ts';

export const coordinatesFromSearch = (
  search: CompSearch,
  locationBoundary: LocationBoundary | undefined,
) => {
  if (search.geoSearch.t === 'polygon') {
    return search.geoSearch.coords.map(([longitude, latitude]) => ({
      latitude,
      longitude,
    }));
  }
  if (search.geoSearch.t === 'municipality' && locationBoundary) {
    return locationBoundary.coords.map(({ longitude, latitude }) => ({
      latitude,
      longitude,
    }));
  }
  return [];
};
